import { apiFetch } from './utils/api';

export const accountTeam = {
  get: async () => {
    const options = {
      method: 'GET',
    };

    const url = '/v2/account-team';
    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
